import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { FadeUp } from '../ui/FadeUp';
export function FinalCTASection() {
  return <SectionWrapper bgColor="charcoal" id="final-cta" className="text-center !py-20" data-id="element-55">
      <FadeUp data-id="element-56">
        <p className="text-[12px] tracking-[0.12em] uppercase text-border-custom mb-5" data-id="element-57">
          La decisión es tuya
        </p>
      </FadeUp>

      <FadeUp delay={0.1} data-id="element-58">
        <h2 className="text-[clamp(32px,9vw,48px)] text-ivory mb-4" data-id="element-59">
          Podés seguir reaccionando… o podés empezar a{' '}
          <em className="italic text-gold-light" data-id="element-60">regularte.</em>
        </h2>
      </FadeUp>

      <FadeUp delay={0.2} data-id="element-61">
        <p className="text-[14px] text-border-custom mb-9 leading-[1.6]" data-id="element-62">
          El sistema que te devuelve el control sobre tu estado interno.
        </p>
      </FadeUp>

      <FadeUp delay={0.3} data-id="element-63">
        <div className="max-w-[340px] mx-auto" data-id="element-64">
          <a href="https://checkout.pro-mind.solutions/checkouts/cn/hWNAxKDnoY7mzFOuDC4SI1WE/es-ar?_r=AQABGqTnZJyZD3IbAB-NySxfbgYwLfinNd204o62SjZgPkg&preview_theme_id=157919314137" target="_blank" rel="noopener noreferrer" className="block w-full bg-gold text-plum-deep border-none p-[20px_24px] font-sans text-[15px] font-semibold tracking-[0.03em] text-center rounded-[6px] transition-transform active:scale-[0.98] relative overflow-hidden no-underline" data-id="element-65">
            <span className="relative z-10" data-id="element-66">Quiero recuperar mi eje →</span>
            <div className="absolute inset-0 z-0 bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.15),transparent)] bg-[length:200%_100%] animate-shimmer" data-id="element-67" />
          </a>
        </div>
      </FadeUp>
    </SectionWrapper>;
}